// extracted by mini-css-extract-plugin
export default {"divisionCell":"divisionCell-AgcaAeST","divisionImage":"divisionImage-xCoKpQix","clickable":"clickable-Ba1vTsTs","subdivisionImage":"subdivisionImage-Ax0hnmeE"};